import React from "react";

export function completeRows(card, drawn) {
  const set = new Set(drawn || []);
  return card.map((row, i) => (row.every((n) => n === null || set.has(n)) ? i : -1)).filter((i) => i >= 0);
}

export function BingoCard({ card, drawn, highlight = true, winRows = [] }) {
  const drawnSet = new Set(drawn || []);
  const winSet = new Set(winRows);
  return (
    <div
      data-testid="bingo-card"
      className="w-full grid grid-cols-9 gap-1.5 p-3 rounded-2xl bg-[#12141D] border border-[rgba(255,215,0,0.25)] shadow-[0_0_40px_-10px_rgba(255,215,0,0.4)]"
    >
      {card.flat().map((n, idx) => {
        const isMarked = n !== null && drawnSet.has(n);
        const inWinRow = winSet.has(Math.floor(idx / 9));
        return (
          <div
            key={idx}
            data-testid={n !== null ? `card-cell-${n}` : `card-cell-empty-${idx}`}
            data-winrow={inWinRow ? "true" : undefined}
            className={`aspect-square flex items-center justify-center rounded-md text-sm sm:text-base font-black transition-all duration-300 ${
              n === null
                ? inWinRow ? "bg-[#00E676]/15 ring-1 ring-[#00E676]/40" : "bg-transparent"
                : inWinRow
                ? "bg-[#00E676] text-[#0B0C10] ring-2 ring-[#00E676] shadow-[0_0_18px_rgba(0,230,118,0.9)] scale-105"
                : isMarked && highlight
                ? "bg-[#FFD700] text-[#0B0C10] scale-105 shadow-[0_0_15px_rgba(255,215,0,0.8)]"
                : "bg-[#1F2833] text-slate-100 border border-white/10"
            }`}
          >
            {n === null ? "" : n}
          </div>
        );
      })}
    </div>
  );
}

export function CalledBoard({ drawn, currentBig = false }) {
  const drawnSet = new Set(drawn || []);
  const last = drawn && drawn.length > 0 ? drawn[drawn.length - 1] : null;
  return (
    <div
      data-testid="called-board"
      className="grid grid-cols-10 gap-1.5 sm:gap-2 p-3 sm:p-4 rounded-2xl bg-[#0B0C10] border border-white/10"
    >
      {Array.from({ length: 90 }, (_, i) => i + 1).map((n) => {
        const isCalled = drawnSet.has(n);
        const isLast = n === last;
        return (
          <div
            key={n}
            data-testid={`board-num-${n}`}
            className={`aspect-square flex items-center justify-center rounded-md font-black transition-all duration-500 ${
              currentBig ? "text-lg sm:text-2xl" : "text-xs sm:text-sm"
            } ${
              isLast
                ? "bg-[#00F0FF] text-[#0B0C10] scale-110 shadow-[0_0_30px_rgba(0,240,255,0.9)] animate-pulse"
                : isCalled
                ? "bg-[#FFD700] text-[#0B0C10] shadow-[0_0_8px_rgba(255,215,0,0.5)]"
                : "bg-[#1F2833]/60 text-slate-500 border border-white/5"
            }`}
          >
            {n}
          </div>
        );
      })}
    </div>
  );
}

export function CurrentBall({ number, size = "text-8xl lg:text-9xl" }) {
  return (
    <div
      data-testid="current-ball"
      className="relative flex flex-col items-center justify-center"
    >
      <div className="relative w-40 h-40 sm:w-56 sm:h-56 lg:w-72 lg:h-72 rounded-full flex items-center justify-center bg-gradient-to-br from-[#FFD700] via-[#FFA500] to-[#FF007F] shadow-[0_0_80px_20px_rgba(255,215,0,0.5)]">
        <div className="absolute inset-2 rounded-full bg-[#0B0C10] flex items-center justify-center">
          <span className={`${size} font-black tracking-tighter text-[#FFD700]`}
                style={{ fontFamily: "Unbounded, sans-serif" }}>
            {number ?? "—"}
          </span>
        </div>
        <div className="absolute top-6 left-8 w-12 h-6 rounded-full bg-white/30 blur-md" />
      </div>
    </div>
  );
}
